/**
 * CalculatorIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CalculatorIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M7.5 6h9a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5" />
    <path
      fillRule="evenodd"
      d="M5 2h14a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2m0 2v16h14V4z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const CalculatorIcon = makeIcon('CalculatorIcon', CalculatorIconSvg)
